import { render, staticRenderFns } from "./LoyaltyTier.vue?vue&type=template&id=9cd88ac2&scoped=true&"
import script from "./LoyaltyTier.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTier.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyTier.vue?vue&type=style&index=0&id=9cd88ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd88ac2",
  null
  
)

export default component.exports